import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { FormGroup } from '@mc/react-core';
import classNames from 'classnames';
import {
  RF_ACTIVE,
  RF_DISABLED,
  RF_ERROR,
  RF_FORM_GROUP,
  RF_REQUIRED,
  //   RF_WARNING,
} from '../classes';
import { Field } from '../Field';
import { HelperText, HelperType } from '../HelperText';
import { RffFieldProps } from '../FieldProps';
import { useTheme } from '../useTheme';
type Props = {
  name: string;
  input: React.ComponentType<any> /**
   * {
    value: any;
    onChange: React.ChangeEventHandler<any>;
    onBlur: React.FocusEventHandler<any>;
    required?: boolean;
    disabled?: boolean;
  }
   */;
  label: React.ReactNode;
  required?: boolean;
  disabled?: boolean;
} & RffFieldProps;

export const Base: React.FC<Props> = ({
  name,
  input: InputComponent,
  required,
  validate,
  label,
  disabled,
  type,
  ...other
}) => {
  const { ns } = useTheme();
  return (
    <Field name={name} validate={validate} type={type}>
      {({ meta, input }: FieldRenderProps<any, HTMLElement>) => {
        let cls = classNames(
          RF_FORM_GROUP,
          'bp3-floating-form-group',
          `${ns}-ff-form-item`,
          {
            [RF_ERROR]: meta.touched && (meta.error || meta.submitError),
            [RF_ACTIVE]: !!input.value || input.value === 0, //document.activeElement === ref.current,
            [RF_DISABLED]: disabled,
            [RF_REQUIRED]: required,
          }
        );

        let helperText = null;
        if (meta.touched) {
          if (meta.error || meta.submitError) {
            helperText = (
              <HelperText type={HelperType.ERROR}>
                {meta.error || meta.submitError}
              </HelperText>
            );
          } else if (meta.pristine && (meta.error || meta.submitError)) {
            // TODO warning
            helperText = (
              <HelperText type={HelperType.WARNING}>
                {meta.error || meta.submitError}
              </HelperText>
            );
          }

          // TODO meta.asyncValidating, meta.autofilled
        }

        return (
          <FormGroup className={cls} label={label} disabled={disabled}>
            <InputComponent {...input} {...other} disabled={disabled} />
            {helperText}
          </FormGroup>
        );
      }}
    </Field>
  );
};
